import * as React from 'react';

function SvgEmail(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M21.75 3.75H2.25a.75.75 0 00-.75.75v15c0 .415.335.75.75.75h19.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75zm-.938 2.597v12.216H3.188V6.347l-.646-.504.92-1.184 1.004.78h15.073l1.003-.78.92 1.184-.648.504zm-1.274-.91L12 11.297l-7.537-5.86-1.004-.78-.92 1.184.646.504 8.006 6.224a1.312 1.312 0 001.61 0l8.011-6.222.647-.504-.92-1.184-1.002.779z" />
    </svg>
  );
}

export default SvgEmail;
